import { render, staticRenderFns } from "./RecognitionWizard.vue?vue&type=template&id=4c4f33fc&scoped=true"
import script from "./RecognitionWizard.vue?vue&type=script&lang=js"
export * from "./RecognitionWizard.vue?vue&type=script&lang=js"
import style0 from "./RecognitionWizard.vue?vue&type=style&index=0&id=4c4f33fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4f33fc",
  null
  
)

export default component.exports